export const PanelTypes = {
  SHARP: 'SHARP',
  ROUNDED_SLIGHT: 'ROUNDED_SLIGHT',
  ROUNDED_MEDIUM: 'ROUNDED_MEDIUM',
  ROUNDED_BURLY: 'ROUNDED_BURLY',
};
